import { logEvent, setUserId, setUserProperties } from 'firebase/analytics';
import * as fb from './firebase';

// Queue events that fire before analytics finishes async init.
const queue = [];
let flushed = false;

function flush() {
  if (flushed || !fb.analytics) return;
  flushed = true;
  while (queue.length) {
    const { name, params } = queue.shift();
    try { logEvent(fb.analytics, name, params); } catch {}
  }
}

export function track(name, params = {}) {
  if (!fb.analytics) {
    queue.push({ name, params });
    // Try again shortly in case init resolves between calls.
    if (typeof window !== 'undefined') setTimeout(flush, 250);
    return;
  }
  flush();
  try { logEvent(fb.analytics, name, params); } catch {}
}

export function trackPage(view) {
  track('page_view', { page_title: view, page_path: `/${view}` });
}

export function identify(uid, props = {}) {
  if (!fb.analytics) return;
  try {
    if (uid) setUserId(fb.analytics, uid);
    if (props && Object.keys(props).length) setUserProperties(fb.analytics, props);
  } catch {}
}
